// https://api.smash.gg/characters?videogameId=1386
const ult = {
    "character": [{
            "id": 1271,
            "name": "Bayonetta",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227931,
                    "width": 2057,
                    "height": 2057,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1271/image-663b9867527c516581b5234d94e6ae04.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227932,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1271/image-371174b820db9018017a06988c546203.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1272,
            "name": "Bowser Jr.",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227933,
                    "width": 1442,
                    "height": 1442,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1272/image-16643510c4058547f197af6fda965cd3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227934,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1272/image-304bcf080f20eb5405d9f855f931b7ab.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1273,
            "name": "Bowser",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227935,
                    "width": 1386,
                    "height": 1386,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1273/image-65f64822e590e8d44f00e6940cd2b132.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227936,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1273/image-ef8a42ec3c7d05279e1a7c9ccc213591.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1274,
            "name": "Captain Falcon",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227949,
                    "width": 1795,
                    "height": 1795,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1274/image-02a2ddbf81be1a3d62fafb195e7a7560.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227950,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1274/image-2d8d86a2b1ad264e48b809f66be1fa1b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1275,
            "name": "Cloud",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227951,
                    "width": 1929,
                    "height": 1929,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1275/image-efa64e9456aa10682a7f81d7b74bc99b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227952,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1275/image-354129bab0aa613d617cbb3ff095a70a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1276,
            "name": "Corrin",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227953,
                    "width": 1992,
                    "height": 1992,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1276/image-cbf8b1251235d4959b7967bdaab8e8a4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227954,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1276/image-13110600e5d35c17ac0186c4af78a1f7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1277,
            "name": "Daisy",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227955,
                    "width": 1844,
                    "height": 1844,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1277/image-3059cb5d31a50e36207014fff2b6929d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227956,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1277/image-286f3a96969c0f13a37cd89cf3d66a19.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1278,
            "name": "Dark Pit",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227957,
                    "width": 1384,
                    "height": 1384,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1278/image-6445671546b37ff8f85ec551287b90d9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227958,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1278/image-9cacbc80e4af52b90a83e4f2ab7e60d8.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1279,
            "name": "Diddy Kong",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227959,
                    "width": 1356,
                    "height": 1356,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1279/image-e9d92d3ca38957c8b536bc530af6d56b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227960,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1279/image-38d006b1878b11418aecbe9770facf62.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1280,
            "name": "Donkey Kong",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227961,
                    "width": 1403,
                    "height": 1403,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1280/image-556da14cc7d9aa34425fe52ca386f07d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227962,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1280/image-9680c258ad520dab07302555559f8149.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1282,
            "name": "Dr. Mario",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227968,
                    "width": 1379,
                    "height": 1379,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1282/image-911dc213572c757c36cc3fc7563c4971.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227969,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1282/image-f737994279feb13864b3d396e7088859.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1283,
            "name": "Duck Hunt",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227970,
                    "width": 1363,
                    "height": 1363,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1283/image-843d948f04a34f7c1673117bce674bce.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227971,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1283/image-6e9518b5a239516afc62980ca204bfbe.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1285,
            "name": "Falco",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227974,
                    "width": 1678,
                    "height": 1678,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1285/image-6e0d193cb3f360020ce8322e1dc7564f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227975,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1285/image-9e61f7a91a6c642bc3f14409f6f1cb69.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1286,
            "name": "Fox",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227976,
                    "width": 1537,
                    "height": 1537,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1286/image-f439322fa501ed12f28c75460a669619.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227977,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1286/image-14f14c0145535ab65ae8c2bdd9196b3d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1287,
            "name": "Ganondorf",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227978,
                    "width": 1886,
                    "height": 1886,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1287/image-0f76341bf3d23662321b7f93a892c9c0.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227979,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1287/image-7b7e1497962c398ac8c8092aca493e89.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1289,
            "name": "Greninja",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227982,
                    "width": 1658,
                    "height": 1658,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1289/image-05716c197777a99f6b8af81de2ae4d60.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227983,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1289/image-cc620acf7dd40071f90d624a11d1cd3d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1290,
            "name": "Ice Climbers",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227984,
                    "width": 1464,
                    "height": 1464,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1290/image-be50ee8c12a84f769850f29075fda833.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227985,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1290/image-14a222a328cccd5270e987d8e630c87b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1291,
            "name": "Ike",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227986,
                    "width": 1913,
                    "height": 1913,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1291/image-148d76285ff7291866b3fe09d8592e67.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227987,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1291/image-47c500b77e87baf46a11f9214eda101c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1292,
            "name": "Inkling",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227988,
                    "width": 1585,
                    "height": 1585,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1292/image-8eeecd56d9d27465f76932c4d556db0a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227989,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1292/image-af172ef6e2da4bb33409821b91610472.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1293,
            "name": "Jigglypuff",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227990,
                    "width": 890,
                    "height": 890,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1293/image-9b3e4e818657221eb6206f30cde679ef.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227991,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1293/image-327deaa1e363b2012a55ea31362ff4e1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1294,
            "name": "King Dedede",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227992,
                    "width": 1307,
                    "height": 1307,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1294/image-e96cf494619d13dc54aefe1c5473ff21.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227993,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1294/image-b6c14001355f8693329a32f2065bdca3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1295,
            "name": "Kirby",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227994,
                    "width": 1276,
                    "height": 1276,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1295/image-ae14cad627398cf474b7991fd23f3a66.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227995,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1295/image-58aeb3c055e3bfa9bdb357e6338c3b3d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1296,
            "name": "Link",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1227998,
                    "width": 1604,
                    "height": 1604,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1296/image-faa5e06f6d2d6a460ba135948b967054.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1227999,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1296/image-6ea5f502c7b6d0dc9483b0bcba895fda.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1297,
            "name": "Little Mac",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228000,
                    "width": 1779,
                    "height": 1779,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1297/image-62942ca5efef67550784c89e545264a5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228001,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1297/image-f8aa345e461f796b94d66c0b412fefca.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1298,
            "name": "Lucario",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228002,
                    "width": 1509,
                    "height": 1509,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1298/image-1cc9cc49370c5391b7262184b7e2fb11.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228003,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1298/image-620452417358ec75b3e44f924d13c631.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1299,
            "name": "Lucas",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228004,
                    "width": 1306,
                    "height": 1306,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1299/image-9388015177b3c30b75247cb133735d63.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228005,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1299/image-6e84ea41fe27f12d2419ec2eaf164c09.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1300,
            "name": "Lucina",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228006,
                    "width": 1677,
                    "height": 1677,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1300/image-b415e5e626f35733c437a2391c10e20a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228007,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1300/image-37b6105a4f599756c3c599e30ef69927.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1301,
            "name": "Luigi",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228008,
                    "width": 1209,
                    "height": 1209,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1301/image-c9287a3086dfe83b32b01e8bfd4aacf6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228009,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1301/image-ea4deed209104775ac064705e2abc4e0.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1302,
            "name": "Mario",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228010,
                    "width": 1074,
                    "height": 1074,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1302/image-45c386649943e14102eabcd2563b1597.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228011,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1302/image-36bc4aedc5311b7c7923ef148af31e79.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1304,
            "name": "Marth",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228012,
                    "width": 1749,
                    "height": 1749,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1304/image-9122b0f59c3f34508818fc1769de1f4e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228013,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1304/image-eefba4d63ebc529039975f27fca61843.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1305,
            "name": "Mega Man",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228014,
                    "width": 1480,
                    "height": 1480,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1305/image-ac2c55364df69ec07dc31f7ef16fbe88.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228015,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1305/image-7c5e2ec77199cbda9bcf7cf1e69e0c83.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1307,
            "name": "Meta Knight",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228018,
                    "width": 1682,
                    "height": 1682,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1307/image-08182f21bed5ada8661afbccd2c59977.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228019,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1307/image-d3c8d48f610c4e51bb72f4f5571e6f58.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1310,
            "name": "Mewtwo",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228046,
                    "width": 1668,
                    "height": 1668,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1310/image-62869dadf26fc647dd18f40c7bd2f185.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228047,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1310/image-871401692876a9ba43b183aa9ffdef50.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1311,
            "name": "Mii Brawler",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1408069,
                    "width": 250,
                    "height": 250,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1311/image-cb3c8d3c74fab10e3dec6ae61bf41ced.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1408070,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1311/image-f6cd7a894956ae95c15c11cc9bfdbb98.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1313,
            "name": "Ness",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228052,
                    "width": 1289,
                    "height": 1289,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1313/image-87fd8b4664526806a1fe7b5a7c11d04d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228053,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1313/image-3870ed5a1c84b3979055a5c5014eb3cb.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1314,
            "name": "Olimar",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228054,
                    "width": 1207,
                    "height": 1207,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1314/image-1a51ad5c9aa104964de0e7dd6f1de550.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228055,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1314/image-d60bc7012d14c2b8b0810e1db3283b22.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1315,
            "name": "Pac-Man",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228056,
                    "width": 1202,
                    "height": 1202,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1315/image-676b2ec3b5e7659e1b0e4a7d414419ea.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228057,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1315/image-b14b37d880b99bd5ef8e5ad50154040d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1316,
            "name": "Palutena",
            "isCommon": true,
            "videogameId": 1386,
            "images": [{
                    "id": 1228058,
                    "width": 1578,
                    "height": 1578,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1316/image-192812cef102b351209b97c7214e40a7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228059,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1316/image-3fab6611ff1cb12578ef5bed59c42ec3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1317,
            "name": "Peach",
            "isCommon": true,
            "videogameId": 1386,
            "images": [{
                    "id": 1228060,
                    "width": 1545,
                    "height": 1545,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1317/image-339638653833b0f80e4842af01bd44fd.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228061,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1317/image-0bea128a48c43f13c25bf6b1eb6e6a20.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1318,
            "name": "Pichu",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228062,
                    "width": 1239,
                    "height": 1239,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1318/image-54d436fcfe3db0d23f0fe2ba0be7f7dc.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228063,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1318/image-681a1adc3d30a20912e1cee2eabca5e3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1319,
            "name": "Pikachu",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228064,
                    "width": 1166,
                    "height": 1166,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1319/image-e74ac05de24c0adbaf833ec89e77ecbd.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228065,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1319/image-3cd77b7121324b75767766159c93e7c5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1320,
            "name": "Pit",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228066,
                    "width": 1292,
                    "height": 1292,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1320/image-12b542d3fb0cb0186de555cc857a95e0.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228067,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1320/image-f40b11b0016d86d7e48ab258c021422d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1321,
            "name": "Pokemon Trainer",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228068,
                    "width": 1656,
                    "height": 1656,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1321/image-887718ac4e2d9de2f79e10489a0148c6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228069,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1321/image-afd5457b505f5d4893a0c2ee305787b7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1322,
            "name": "Ridley",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228070,
                    "width": 1839,
                    "height": 1839,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1322/image-181150b4fe0f9345faf51a36289afc39.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228071,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1322/image-6944a1e50f8a87e11886b885db4bf0a8.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1323,
            "name": "R.O.B.",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228072,
                    "width": 1316,
                    "height": 1316,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1323/image-bebbc266a5ec554d0b68f193da72898a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228073,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1323/image-ff45bd739bb70c5b557247b071757f9c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1324,
            "name": "Robin",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228074,
                    "width": 1916,
                    "height": 1916,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1324/image-4bb6697fbf624bf83634bb7d3949559b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228075,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1324/image-05e9da41d7e8c97d4ff5aba0ee177701.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1325,
            "name": "Rosalina",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228076,
                    "width": 1606,
                    "height": 1606,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1325/image-8513bdb3796144c44a9b213f41b38411.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228077,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1325/image-eea6436958890f8e82dcf19582627c57.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1326,
            "name": "Roy",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228078,
                    "width": 1610,
                    "height": 1610,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1326/image-eed78ad4b6a574432afbde9ef8eed937.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228079,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1326/image-48f829e07a9c6b6ab3490116006cf71e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1327,
            "name": "Ryu",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228081,
                    "width": 2300,
                    "height": 2300,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1327/image-596f10311322a8749135fc1aa82aef35.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228082,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1327/image-f680169f233a868049f89dc0dc28888b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1328,
            "name": "Samus",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228083,
                    "width": 2226,
                    "height": 2226,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1328/image-2ee3f11490ba05f6136b8df8cc2ab63a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228084,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1328/image-744eac2adeab1e55acfc3ef07054d635.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1329,
            "name": "Sheik",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228085,
                    "width": 1873,
                    "height": 1873,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1329/image-19be7d7788477d274d000e375afa3fdb.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228086,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1329/image-4fce14113b0fd3758804ba63f0bb93a5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1330,
            "name": "Shulk",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228087,
                    "width": 1835,
                    "height": 1835,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1330/image-be2a9672be52154230e3722fd4d4a7f7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228088,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1330/image-71f53c3c1ad926c1ae68a0bb558fa5ad.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1331,
            "name": "Snake",
            "isCommon": true,
            "videogameId": 1386,
            "images": [{
                    "id": 1228089,
                    "width": 1918,
                    "height": 1918,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1331/image-91ae1a4e90032de4c13433438821ef38.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1609215,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1331/image-3b5e98b24889837ae8e28b2a7eebe4f4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1332,
            "name": "Sonic",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228091,
                    "width": 1706,
                    "height": 1706,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1332/image-62d91ad8fe7412d2b9c2f39020b84de4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228092,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1332/image-320255f78b2f9448b838495068eddc50.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1333,
            "name": "Toon Link",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228093,
                    "width": 1206,
                    "height": 1206,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1333/image-8dd8dd41dd3a814911f1070839ebc487.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228094,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1333/image-f6f2326cf212a37de4cd247d3a22c125.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1334,
            "name": "Villager",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228095,
                    "width": 1164,
                    "height": 1164,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1334/image-5c7caa8208d1a3208a2280f99c6d64f3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228096,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1334/image-03bedf358a8e26041a5e4b4205f5b7e7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1335,
            "name": "Wario",
            "isCommon": true,
            "videogameId": 1386,
            "images": [{
                    "id": 1228097,
                    "width": 1361,
                    "height": 1361,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1335/image-8a84094c9dc9924aaa12bcb256a8e1dc.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228098,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1335/image-914d0e656e6af3459e82cebb0fe9b478.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1336,
            "name": "Wii Fit Trainer",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228099,
                    "width": 2208,
                    "height": 2208,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1336/image-237b5c9ee44a11fef552738a1dc5ede3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228100,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1336/image-c0a2b84d0e4d63a9b91493c711ac4845.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1337,
            "name": "Wolf",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228101,
                    "width": 1419,
                    "height": 1419,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1337/image-b0bc730c59995960da9ed04508929948.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228102,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1337/image-9feb1e0a28cc77d6d180088c9df1d20e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1338,
            "name": "Yoshi",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228103,
                    "width": 1205,
                    "height": 1205,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1338/image-c861342d9e4129d0f16c4dabac07f5dd.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228104,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1338/image-86e5d2590efcb0d85b3337b456642eaa.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1339,
            "name": "Young Link",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228105,
                    "width": 1256,
                    "height": 1256,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1339/image-ce9f4bfbed25d2e405a68b13dd015848.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228106,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1339/image-b32ed8337c8a9f5c42ad80806b77afd9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1340,
            "name": "Zelda",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228107,
                    "width": 1584,
                    "height": 1584,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1340/image-72f6ea9f9292fbef7d65b560c1c78030.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228108,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1340/image-69a5cd75f8fce5c015f5d707ba2cceb1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1341,
            "name": "Zero Suit Samus",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1228109,
                    "width": 2228,
                    "height": 2228,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1341/image-92320c36cd16ae3ca08fa04411e78fff.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1228110,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1341/image-7c0c70110071ed9a863e712469118d10.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1405,
            "name": "Mr. Game & Watch",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1362517,
                    "width": 1322,
                    "height": 1322,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1405/image-ddb6befbf7b92039cc8b584427e27c29.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1362518,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1405/image-b4c985b379395ad83fdb6ca689b23fd8.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1406,
            "name": "Incineroar",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367939,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1406/image-5aa95735d85c658f6000a51b4a3ac43f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367940,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1406/image-e66a5e0dd02730157c94f4b3a4869d86.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1407,
            "name": "King K. Rool",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367955,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1407/image-c8adee7aaf47b788e22ad79842aba06c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367956,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1407/image-649a64550b8848a082dbf9b8d6e545d1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1408,
            "name": "Dark Samus",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367958,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1408/image-9e09a61041db28b51ff67b1dae1200fc.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367959,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1408/image-b5f4017289fb39d73e38449caf4d3fa6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1409,
            "name": "Chrom",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367960,
                    "width": 1199,
                    "height": 1199,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1409/image-734cc51548adf3e8fdc41420744c594a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367961,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1409/image-b74c6742556be07ab4011c15a951cbe2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1410,
            "name": "Ken",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367963,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1410/image-2df45438160cb3aef91c4dc47d1ecec7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367964,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1410/image-1dbe6ec2e0f0f2cbb9d462ec5a406325.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1411,
            "name": "Simon Belmont",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367965,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1411/image-6cb088e7f6fe43caec304d3524513038.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367966,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1411/image-8772fcc758244d775edb478d3bc6fd47.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1412,
            "name": "Richter",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367967,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1412/image-b9ab7c4247a9207f80ffaac9180110f2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367968,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1412/image-de8ea9e1af72aa1a5f4ae8149f91684b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1413,
            "name": "Isabelle",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1367969,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1413/image-c18c9935fff6aed2b48196e9abcc5807.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1367970,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1413/image-7407ea4e4266c4ff185f9582aee2b5ea.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1414,
            "name": "Mii Swordfighter",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1408072,
                    "width": 250,
                    "height": 250,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1414/image-71f0b92dd4ee9ac0d22088fbcabaf21f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1408073,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1414/image-8635c2934d2844518790c528b215991c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1415,
            "name": "Mii Gunner",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1408074,
                    "width": 250,
                    "height": 250,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1415/image-337bae66697b2d49b23a50bcad02927c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1408075,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1415/image-5eb42a77dd8766553ff2f09743e79848.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1441,
            "name": "Piranha Plant",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1417496,
                    "width": 600,
                    "height": 600,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1441/image-71cc30a8413b327d89220dbb29f489e3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1417497,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1441/image-b9aa4a03697eab36005ba72baa526be6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1453,
            "name": "Joker",
            "isCommon": true,
            "videogameId": 1386,
            "images": [{
                    "id": 1517362,
                    "width": 499,
                    "height": 499,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1453/image-c20b242549ef4e04a470a5225c1d862c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1609214,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1453/image-b284052b845b6584f82c5c6d7dd71c55.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1526,
            "name": "Hero",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1681866,
                    "width": 1846,
                    "height": 1846,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1526/image-d89d5b73058a7ca57f0c0e214fdcb82b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1681867,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1526/image-02bc44c2a40238cd0b7b1847d3a257a7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1530,
            "name": "Banjo-Kazooie",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1749265,
                    "width": 1024,
                    "height": 1024,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1530/image-90dfbd7e1ab1e61233a29352f7eacb8f.jpg",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1749266,
                    "width": 800,
                    "height": 800,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1530/image-5ef03faf51cfbe514495cfef35281c8c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1532,
            "name": "Terry",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 1877290,
                    "width": 1200,
                    "height": 1200,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1532/image-d9bd16002efdb1ccaa83e2edc6ebba89.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1877291,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1532/image-53d1155c7c6909c3d652fc7ddd7e03b4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1539,
            "name": "Byleth",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 2328432,
                    "width": 547,
                    "height": 547,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1539/image-b7105f7415b31fc22b38ee4f44b34955.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2328433,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1539/image-b55837a85330e90ae6390927cfec51c4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1746,
            "name": "Random Character",
            "isCommon": false,
            "videogameId": 1386,
            "images": [{
                    "id": 2655584,
                    "width": 258,
                    "height": 258,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1746/image-485930109cf8a08e1b05d21071a037e9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2655585,
                    "width": 258,
                    "height": 258,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1746/image-485930109cf8a08e1b05d21071a037e9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1747,
            "name": "Min Min",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 2710865,
                    "width": 600,
                    "height": 600,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1747/image-a1c61127430f264db333fae5880bb1d4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2710868,
                    "width": 50,
                    "height": 50,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1747/image-81170ff730d030f453c31dbe5c6dcbd7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1766,
            "name": "Steve",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 2981800,
                    "width": 256,
                    "height": 256,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1766/image-ede4cd37a910141a8dce27fd5f41af58.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2981801,
                    "width": 50,
                    "height": 50,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1766/image-02314caeff10895f38d749e9f458ca85.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1777,
            "name": "Sephiroth",
            "isCommon": true,
            "videogameId": 1386,
            "images": [{
                    "id": 3125480,
                    "width": 250,
                    "height": 250,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1777/image-415777e1ccc94cad2c7807617c6af921.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3125481,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1777/image-1e7b275803dc9ed66bc2c82f4d5e166c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1795,
            "name": "Pyra & Mythra",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 3321982,
                    "width": 2500,
                    "height": 2500,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1795/image-2b918ac0ea6d413f9d4c984eb7a3b353.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3321983,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1795/image-83a44f4da59e0e2471c1966efce7fe79.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1846,
            "name": "Kazuya",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 3647021,
                    "width": 250,
                    "height": 250,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1846/image-2ed36a24c86842fecc3e9179ef8a7aff.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3675614,
                    "width": 200,
                    "height": 200,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1846/image-3396c2649f5e7ef0197aca3ac2c12970.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        },
        {
            "id": 1897,
            "name": "Sora",
            "isCommon": null,
            "videogameId": 1386,
            "images": [{
                    "id": 3929075,
                    "width": 1550,
                    "height": 1550,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1897/image-49660813e238ff96670485daf73e1366.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3929076,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1897/image-9547cd1baf85613d329aaa2847f7d1fe.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": []
        }
    ],
    "result": [
        1271,
        1272,
        1273,
        1274,
        1275,
        1276,
        1277,
        1278,
        1279,
        1280,
        1282,
        1283,
        1285,
        1286,
        1287,
        1289,
        1290,
        1291,
        1292,
        1293,
        1294,
        1295,
        1296,
        1297,
        1298,
        1299,
        1300,
        1301,
        1302,
        1304,
        1305,
        1307,
        1310,
        1311,
        1313,
        1314,
        1315,
        1316,
        1317,
        1318,
        1319,
        1320,
        1321,
        1322,
        1323,
        1324,
        1325,
        1326,
        1327,
        1328,
        1329,
        1330,
        1331,
        1332,
        1333,
        1334,
        1335,
        1336,
        1337,
        1338,
        1339,
        1340,
        1341,
        1405,
        1406,
        1407,
        1408,
        1409,
        1410,
        1411,
        1412,
        1413,
        1414,
        1415,
        1441,
        1453,
        1526,
        1530,
        1532,
        1539,
        1746,
        1747,
        1766,
        1777,
        1795,
        1846,
        1897
    ],
    "resultEntity": "character",
    "actionRecords": []
}

// https://api.smash.gg/characters?videogameId=1
const melee = {
    "character": [{
            "id": 1,
            "name": "Bowser",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 222541,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1/image-e037c945926ed3c455e6f3844dd2c4c3.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 222542,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1/image-d361497783179b19e3ec2f0f1243a2b9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394586,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1/image-f7fb27e0d7e18cae4a75e61673b8bc57.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394587,
                    "width": 120,
                    "height": 120,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1/image-95a7211ee056b2f1a46aec549f0689fd.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 2,
            "name": "Captain Falcon",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 224960,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/2/image-b3c33a1a600b53fd7d0750d38f37e665.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 224961,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/2/image-7282d9b5d95f84cba80bf8969ca2aac4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394595,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/2/image-91a9e06ab48ffc4fb21f1933db6d7d5e.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394596,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/2/image-d6b057a186dc44311b6e972ddab2559a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 3,
            "name": "Donkey Kong",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220071,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/3/image-803995c0e10bc359ea6a7fb7a9f23e78.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220072,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/3/image-a02f35b156f390233f3c083e72186259.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394582,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/3/image-0ef52996c57dd1aa93623ab8caa1cc4b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394583,
                    "width": 102,
                    "height": 102,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/3/image-686c2e80770481a6460f62dc524c3d15.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 4,
            "name": "Dr. Mario",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220075,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/4/image-afe3635350c115deca38e09e01adfce0.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220076,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/4/image-b26c03accbe8c734990a45aff1a0beff.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394580,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/4/image-a959aa6920dcd0f757e5a3ba82de6ffc.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394581,
                    "width": 115,
                    "height": 115,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/4/image-5555068ceb4a4e5e6651fdca5deffa47.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 5,
            "name": "Falco",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220079,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/5/image-325f30eee6631a6989a345e98da764e2.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220080,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/5/image-028eb800914188e33cd544ec36dc8f9e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394578,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/5/image-af088a777207becd83801ff4a4eaaea7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394579,
                    "width": 102,
                    "height": 102,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/5/image-b683f480e49ea46f81fd9bffd740523d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 6,
            "name": "Fox",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220083,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/6/image-55b92279973dc72a6e2ae99b2e22a21c.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220084,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/6/image-c35ebb7c6448393b304c94efab93e07c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394524,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/6/image-ff9bbe458addc5b547b41022efeace14.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394525,
                    "width": 102,
                    "height": 102,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/6/image-90147383eb0cd57fbf60a7b61bceb9ad.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 7,
            "name": "Ganondorf",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220087,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/7/image-d9b5589528a705cfacdc7b7e38144302.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220088,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/7/image-c404518e5be53320677201d9c201e2b9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394576,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/7/image-940bfa73690b45610c8dee0ffa2129bd.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394577,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/7/image-71730993ed51c6a0d781a1a9793cee6d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 8,
            "name": "Ice Climbers",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220091,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/8/image-4466e095b8d678180a3b825eb30d5428.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220092,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/8/image-94e588a2be641033e014238ae2ef9d46.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394574,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/8/image-2a0705aa8fc6878547fbb8f28987ca8c.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394575,
                    "width": 111,
                    "height": 111,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/8/image-6af7fd283e075b4e4d5a1c6eced31cbe.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 9,
            "name": "Jigglypuff",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220095,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/9/image-d985265ef0d8fc9d1c8952132dd99a29.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220096,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/9/image-1d9266653ed5e1e047319d8f47c495b6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394572,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/9/image-ab982f8a75c4d9a01cd6efb7719d7540.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394573,
                    "width": 117,
                    "height": 117,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/9/image-d315f5ba93aa4607acd6486115f29aec.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 10,
            "name": "Kirby",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220099,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/10/image-7d5ad38ba7e001498f6537a6881eeecb.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220100,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/10/image-04cab137b9760ae28b604cd75a87fedf.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394570,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/10/image-08fcf168f628c1259740f7ad3402d281.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394571,
                    "width": 120,
                    "height": 120,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/10/image-fb3f1a522a02833220402f3eed96acd9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 11,
            "name": "Link",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220103,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/11/image-1f0c8f065c0804a053c130d2f355d9fb.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220104,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/11/image-83d23d41d883eee9746fe27f997b444f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394568,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/11/image-4e790b653942bb05de884649d04b4f8b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394569,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/11/image-4c632dfc98d97b5170651d27d02b0f5e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 12,
            "name": "Luigi",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220107,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/12/image-f583318c7efb80b6fa7a3f5e45657670.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220108,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/12/image-ac7a4989fecd146152bfb7649148b66e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394562,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/12/image-a87414d2558e3988d189e1e0d848c890.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394563,
                    "width": 102,
                    "height": 102,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/12/image-9f68005b1a648f8c49bb0e3c21224a76.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 13,
            "name": "Mario",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220111,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/13/image-dfcb808542da6ba2bf41a24e9494f8df.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220112,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/13/image-e1f4a662c16925ee47b5877c2f665f4e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394560,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/13/image-8a664dd6c3e0479ae6c4d2c612bdf527.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394561,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/13/image-7e271cdec4b6f98cb63b7b7694179a57.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 14,
            "name": "Marth",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220115,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/14/image-8c91c208bb2d4215c1428a7254454cff.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220116,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/14/image-e3f25cd411daf66f14bb9918abe28038.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394554,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/14/image-dd0b9de399800279936b732ceca45cbf.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394555,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/14/image-2d7561ebbffbc65868fabe741c5610c6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 15,
            "name": "Mewtwo",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220119,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/15/image-693b316a7d60158d05ff784a4df14434.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220120,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/15/image-18b95f05ea15d8c88185062b8d913ae2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394545,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/15/image-538f7a7a0ee80cdb073d1abe781b29ba.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394546,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/15/image-ccd6119bec81c3e83fb0b632bd116e4c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 16,
            "name": "Mr. Game & Watch",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220123,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/16/image-612796e66ce5c8dacb6693c240fe7665.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220124,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/16/image-8048a2b87a9fdb20fed3921f9dfe9c85.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394543,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/16/image-c583a7ff43e0756f71d685ce3a08d67a.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394544,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/16/image-7d06721309a04a3f90eea08277bc72da.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 17,
            "name": "Ness",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220127,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/17/image-4c1f455042a04dd87660b0ef81405170.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220128,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/17/image-1df57f7b9d934109c47bd56890a61559.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394541,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/17/image-0b2f7266015aaa3f2c3f9aaa6c6df6bf.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394542,
                    "width": 111,
                    "height": 111,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/17/image-9d4395f74427e8eb3407b587091c7b1f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 18,
            "name": "Peach",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220131,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/18/image-d2f96f79292d23ede1d456607ca33384.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220132,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/18/image-81dcc98c2b1655b107450b520ac953a4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394539,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/18/image-0bfbfc9cfbe1bc173d488ede6e53e083.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394540,
                    "width": 107,
                    "height": 107,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/18/image-900e884492974be8794dc9262e2f4d08.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 19,
            "name": "Pichu",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220135,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/19/image-28523cdb65d3f09a88113f52a08e8a02.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220136,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/19/image-8b3bf505cb65449ede9b9961e809b071.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394522,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/19/image-8c0ed4860934b9519723d11ec428e789.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394523,
                    "width": 117,
                    "height": 117,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/19/image-97df138575875b14a62356846337ea2c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 20,
            "name": "Pikachu",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220139,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/20/image-6232a3460eaf76d10c03f5f5724cee19.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220140,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/20/image-b6fa6b95b331f68eb06de792d45a6741.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394520,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/20/image-85681fb0a78ca0b3d372d2801e44a2da.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394521,
                    "width": 103,
                    "height": 103,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/20/image-ac4978641c31f61b9fe8629a13411f2d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 21,
            "name": "Roy",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220143,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/21/image-3e1d15af70444adbbbba169a66d64ffe.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220144,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/21/image-b723fa10f7627fa27106a428b0042b54.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394518,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/21/image-2ae4e21e05b5ec44b84f9ec928212146.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394519,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/21/image-76b051f60d28f3c47db3fe6400afb04b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 22,
            "name": "Samus",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220147,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/22/image-e6d3acbe1b82a1d2ec3c5ea616283997.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220148,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/22/image-952823e54c9f52c1bedac374e44b57e6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394516,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/22/image-0a8106c89fd6adeb8ad3532227202ef0.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394517,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/22/image-e0c7458628dab250d92a029b2b24c055.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 23,
            "name": "Sheik",
            "isCommon": true,
            "videogameId": 1,
            "images": [{
                    "id": 220151,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/23/image-696cf22872b76795f6350dcde8494a70.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220152,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/23/image-080c9df51383311ffa770e3919c32722.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394514,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/23/image-c03e80fc610568a02121354ca76f31a9.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394515,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/23/image-3d3f0228ac9df56df76947a254785553.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 24,
            "name": "Yoshi",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220155,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/24/image-3e88f767758033529cf9d23f5100fac8.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220156,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/24/image-0f120b52cc5fba2a671e7496efebf706.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394512,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/24/image-ffefbb188a4d98abbffa2027e8150ba7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394513,
                    "width": 103,
                    "height": 103,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/24/image-fb125957a83f0a122061415366fbe038.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 25,
            "name": "Young Link",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 220159,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/25/image-0ad438561bd5e7245b36e94f6e5f8bb2.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220160,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/25/image-5fb48e0851ba44605d01f7c9f89c9e38.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 438274,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/25/image-a73fda79a4975a3e5466e756dc3969be.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 438275,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/25/image-625afb9a435144ce85b53c1cc196c5c3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 26,
            "name": "Zelda",
            "isCommon": false,
            "videogameId": 1,
            "images": [{
                    "id": 220163,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/26/image-5538f3b847f4f0b8499290c91b9a4fd9.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220164,
                    "width": 24,
                    "height": 24,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/26/image-4612acefb511ba68d06e349a799786f2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394508,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/26/image-ed0e5091950219ad4e2f900f28b477f7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 394509,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/26/image-a0b6c53bd1d018f4c0de1a633bc011cd.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 628,
            "name": "Sheik / Zelda",
            "isCommon": null,
            "videogameId": 1,
            "images": [{
                    "id": 362204,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/628/image-000bac82f4488b3d52a8a1a7975b7a9c.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 362205,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/628/image-9f95a4a7e35665b393bf0510362f808d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 362206,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/628/image-4812ba52b187ec3e21ee878c3d4f0de7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 362207,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/628/image-e4129026ae751e8c06c053ced2edc08f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1744,
            "name": "Random Character",
            "isCommon": false,
            "videogameId": 1,
            "images": [{
                    "id": 2655586,
                    "width": 258,
                    "height": 258,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1744/image-0ab08b4080246b712623fb4568559c22.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2655587,
                    "width": 258,
                    "height": 258,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1744/image-ee4d02cf4c38c39cdf9dbefac8a17cf1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        }
    ],
    "result": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        628,
        1744
    ],
    "resultEntity": "character",
    "actionRecords": []
}

// https://api.smash.gg/characters?videogameId=33602
const pplus = {
    "character": [{
            "id": 1583,
            "name": "Mario",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220445,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/97/image-3bab929e39cff5c25326a64a0f2a527c.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220446,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/97/image-189b2650d10bf0101388aadd165d426e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220448,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/97/image-7f5f0203d5b41b6dfe3c652ca1451a95.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1584,
            "name": "Luigi",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220449,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/98/image-5bc1cafc05bcba66af699722b7cd7b77.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220450,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/98/image-5d81990170054b37defa389d95b3631d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220452,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/98/image-c71c5fb8b13578e1a39f30801bb0934c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1585,
            "name": "Peach",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220453,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/99/image-b1f423c936fc3eeb36c33da95c851b0d.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220454,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/99/image-a9103bbd8ef32fbcbc0bb3c2fa21d753.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220456,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/99/image-e992ccd578fc01d53b1976c2079d5308.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1586,
            "name": "Bowser",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220457,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/100/image-6e613da46246258be880ec7aad8acac9.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220458,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/100/image-79596c70bf9c7b01b4cd3cf61ffbd591.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220460,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/100/image-51969d5f17035c43f09bf35a36a73b2e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1587,
            "name": "Yoshi",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220461,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/101/image-0f72a98084a4bc3c401327c1f295f236.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220462,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/101/image-d34a4419bb9d805597b0e25849468b49.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220464,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/101/image-f7db7e4155b72855fea38c48557c5910.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1588,
            "name": "Donkey Kong",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220465,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/102/image-862710ad1b9fc828e597df0e757572c8.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220466,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/102/image-6dcaec070899a50cd568efef9bb9e09a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220468,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/102/image-b9753eeaa532ea70555454a217efeaef.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1589,
            "name": "Diddy Kong",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220469,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/103/image-d4b5f6f8fded3caf95fa54950784d989.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220470,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/103/image-2944274c8636f2ad9021b5fe8d31f0f0.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220472,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/103/image-812e996a3c8d9a3a37b6659fc319d81e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1590,
            "name": "Link",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220473,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/104/image-b5a695201e83c775a8dbff8fd8bb7587.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220474,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/104/image-fc49a1dc9faeb40fd1c5d5e871008a46.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220476,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/104/image-ad02059eb839c0ca3a1bf7d780b97190.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1591,
            "name": "Zelda",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220477,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/105/image-5dbc1545b5cf8835b7be56de8e8d7409.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220478,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/105/image-587e01961987ffb0bdb5a0a40d572f23.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220480,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/105/image-9061a0033bec79e7348ef6ed3a205784.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1592,
            "name": "Sheik",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220481,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/106/image-7d01e2b1599950052d474c1e7f1c238b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220482,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/106/image-7cb8a93e4ac706ab544e9f33474f4cc9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220484,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/106/image-b5581453c655e6439ca5bf8d0dc8807a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1593,
            "name": "Ganondorf",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220485,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/107/image-4983f6f994dad9b1f21ed77a0c6fe5e6.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220486,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/107/image-25a877a78bcbb2ad821c14952c5fbb23.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220488,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/107/image-2b476aad961b2febc399f6daac0dfa32.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1594,
            "name": "Toon Link",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220489,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/108/image-30269435b22e2f2ec0b98d85ee247aee.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220490,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/108/image-e5d21e544a64b2301a0bb058cbdca858.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220492,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/108/image-208128aa6b1260c8bd328c43e116d89a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1595,
            "name": "Samus",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220493,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/109/image-292d3a6aac0124b6adc6febbb6e78b57.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220494,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/109/image-228def4c84eb38e2af205be6cfcc8f78.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220496,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/109/image-20448c60954bc115e4a20547a8d66099.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1596,
            "name": "Zero Suit Samus",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220497,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/110/image-e9d31cbe29a6a95440efac1aa87215e8.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220498,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/110/image-5821f229583824a6f400dbc22d3faf15.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220500,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/110/image-9fca2ae491b5e066db93edf467b53c8d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1597,
            "name": "Kirby",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220501,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/111/image-5e83b0b174cbe1660e8ea2e156348805.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220502,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/111/image-9e701b88f2c08a2eb240ddf50867b3dc.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220504,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/111/image-a3bfc93ff7de1499ba81e6ab1b9ead2f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1598,
            "name": "Meta Knight",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220505,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/112/image-9b7e2e67001d7d911a2313457967214f.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220506,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/112/image-75d9d4327c830d78bafc6e5bb258492b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220508,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/112/image-fb0f81dbbe367253018913ce8ebf9df9.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1599,
            "name": "King Dedede",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220509,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/113/image-5bb14ed35155fdab4e8330190c13076a.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220510,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/113/image-29dd48f5b7047fb4e708081e84de529f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220512,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/113/image-c19f3b49256dafed5d0c03b545076e7c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1600,
            "name": "Fox",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220513,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/114/image-675bbef702f1308902237a43cd8f623b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220514,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/114/image-988ac0dbd88f7418431381e29b1dff5b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220516,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/114/image-a447ec3037c94e42eefcc12ad3cdfe37.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1601,
            "name": "Falco",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220517,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/115/image-305894fd0b92c35998507e706ca07a00.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220518,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/115/image-d86b9e688136f874d4bc764a7fd9f69a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220520,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/115/image-18c8bb4eecbab2830d4eec6df030da2f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1602,
            "name": "Wolf",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220521,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/116/image-27150b08340b507198f5ac686d217f59.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220522,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/116/image-240798791b1799f1b2beb560d22b60b1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220524,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/116/image-e4be3d8d8b2553e0eb2de19c86f50d99.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1603,
            "name": "Pikachu",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220525,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/117/image-553d3fe5f744f38a9b359b106acf8b0b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220526,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/117/image-a96033419ed5b6ec0d09ecfa90f46320.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220528,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/117/image-a226dc229ebca9778a12428b3742a1f1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1604,
            "name": "Jigglypuff",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220529,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/118/image-cc395345f9b2ce7a739ec100252374ec.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220530,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/118/image-0c4afdcdbddde048638614e8eb2976d4.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220532,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/118/image-5862f241cbbada35a2b107366728972d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1605,
            "name": "Mewtwo",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220533,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/119/image-7ce17fbd5a0e91692760a85c7eeee70d.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220534,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/119/image-d19a3fe7d5235a8413050ac1eff5ceec.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220536,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/119/image-abed5b0a912ebaeb12d166f683a35421.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1606,
            "name": "Squirtle",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220537,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/120/image-9bcbb69749cc8bd2d4cddd06fe5b76d8.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220538,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/120/image-276b8a712d68b2cc5fd7d1a6933a8531.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220540,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/120/image-04dfc577632cf8cf83a70f3064180837.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1607,
            "name": "Ivysaur",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220541,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/121/image-ea59e8f67578e1c25e97709ca8b76ebe.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220542,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/121/image-4809c4388b31c73d0c98297ea23feeb3.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220544,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/121/image-fda15f8c23e9d017be368fc184b2d111.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1608,
            "name": "Charizard",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220545,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/122/image-fa17c3a5c2a1d641cdfa56fd43ea39b3.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220546,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/122/image-97c2a2854072fadaa7b3cd009f653ba1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220548,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/122/image-722fb1c53a16a8ee7b1f496e98b0eaed.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1609,
            "name": "Lucario",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220549,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/123/image-3eabee186f02fec30b309b0450ffd09b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220550,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/123/image-4573966636a3a344667e1a35fc4664b6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220552,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/123/image-39e7d153c6a18998799138c4c70952b2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1610,
            "name": "Captain Falcon",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220553,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/124/image-e7fb3e8cc106ef4aea4ada0e97afe8ca.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220554,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/124/image-5748a9d34417796d08f1b7ab0b7b201d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220556,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/124/image-f76914aca502452224a7bc462349bf46.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1611,
            "name": "Ness",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220557,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/125/image-f8c4cdf5cbedbf7ccc1912def0e9a9f7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220558,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/125/image-71bc60cfd011736230512f65ff9eb39b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220560,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/125/image-2dd476db6b6ede219e046571fd2fdbdf.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1612,
            "name": "Lucas",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220561,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/126/image-043f95025eb76320e7c96386574638a4.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220562,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/126/image-05c5e282f3b7c9f5ca813bfeacddee2b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220564,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/126/image-0461ad87480ab3bc44bad1c6a588f654.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1613,
            "name": "Ice Climbers",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220565,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/127/image-e10d731f92bebca92ebc3ddfb5e8df57.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220566,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/127/image-9c77864618b7aed860206332351f2ff1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220568,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/127/image-1edfd6d50f674085af7bf34e5aaf7efa.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1614,
            "name": "Marth",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220569,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/128/image-353c1ab923aa458059b9541cb3221407.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220570,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/128/image-d60e45defd52f7def2fb0b6314436628.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220572,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/128/image-02b69caf58ba95ba498a2a9ed804135d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1615,
            "name": "Roy",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220573,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/129/image-11edaf48ae7e161ed6cc4fa11dce840e.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220574,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/129/image-f61bd657c23667f38328da01cad735f1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220576,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/129/image-5a30fd16d797116a0c9d71fbfbb36cbd.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1616,
            "name": "Ike",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220577,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/130/image-d23c3f74a7cf574652f54a2e66476bbf.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220578,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/130/image-3ef4e26de1b682e3d0992bcf1551b14c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220580,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/130/image-224cfe4853f326bcf78d8498589e0bd5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1617,
            "name": "Mr. Game & Watch",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220581,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/131/image-674b4656580de134f34a940808064109.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220582,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/131/image-1a0cad27df126b374e969d7db00ad6bc.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220584,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/131/image-ed6a6268315cd8f502d2f9e76bac9207.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1618,
            "name": "Pit",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220585,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/132/image-d2b3dba203d111562cb35ecc2fe52ead.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220586,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/132/image-9bb2ad8e7dd6c741ce74356e4691b604.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220588,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/132/image-5dc93a6e79e9e9056ce7c7db2e352093.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1619,
            "name": "Wario",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220589,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/133/image-497052fc8da32fe6561d0a9304d2ce97.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220590,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/133/image-f42b2f50c66423f4d5c007fab8164ce5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220592,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/133/image-7e2f563031643a3c8dae4bee093b233c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1620,
            "name": "Olimar",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220593,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/134/image-99a0eef969ed3ac93022f549e0ec17fb.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220594,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/134/image-5315db575f78e41c3700684d7e275fa5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220596,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/134/image-873499a2878795993c106eabc106c937.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1621,
            "name": "ROB",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220597,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/135/image-e368fcec2ab7940cc61c64f3fe223afe.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220598,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/135/image-9e71dd8f09dcf723d2d387cb7e013086.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220600,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/135/image-b20bad49c2a49bf9afb578e640a4118f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1622,
            "name": "Snake",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220601,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/136/image-bf75984fb632fc0a71f63002075244d2.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220602,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/136/image-c6dc8a1ccea47d5b50b2f50115c5c03e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220604,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/136/image-09b60f6ce30ae144645970cd7560954a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1623,
            "name": "Sonic",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 220605,
                    "width": 100,
                    "height": 65,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/137/image-480d4d261dc55916b447a4917fdd83e7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220606,
                    "width": 58,
                    "height": 38,
                    "ratio": 1.53,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/137/image-adc52b02f125a105ac74289e32f1dcbb.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220608,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/137/image-cdee6f91c4d727d54a6d7cb6705440c8.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1624,
            "name": "Sheik/Zelda",
            "isCommon": null,
            "videogameId": 33602,
            "images": [{
                    "id": 354420,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/626/image-9f95a4a7e35665b393bf0510362f808d.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 354421,
                    "width": 115,
                    "height": 115,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/626/image-56c0b2376ae5902c9e433e42227a5bba.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 354422,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/626/image-e4129026ae751e8c06c053ced2edc08f.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 354423,
                    "width": 50,
                    "height": 50,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/626/image-e0a73ea21b99d2653b107bb6b273934f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1627,
            "name": "Knuckles",
            "isCommon": false,
            "videogameId": 33602,
            "images": [{
                    "id": 2437013,
                    "width": 195,
                    "height": 195,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1627/image-6adc3b46d965361f014646e92d892e4e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2437014,
                    "width": 128,
                    "height": 128,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1627/image-7a9f0064cf19b4a71de9191dbf89f661.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1745,
            "name": "Random Character",
            "isCommon": false,
            "videogameId": 33602,
            "images": [{
                    "id": 2655582,
                    "width": 258,
                    "height": 258,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1745/image-04cdec86fc53ef2cbac08bf04fa0abd1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 2655583,
                    "width": 258,
                    "height": 258,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1745/image-52b5ae862d1eb24684620d3104b6a0ed.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        }
    ],
    "result": [
        1583,
        1584,
        1585,
        1586,
        1587,
        1588,
        1589,
        1590,
        1591,
        1592,
        1593,
        1594,
        1595,
        1596,
        1597,
        1598,
        1599,
        1600,
        1601,
        1602,
        1603,
        1604,
        1605,
        1606,
        1607,
        1608,
        1609,
        1610,
        1611,
        1612,
        1613,
        1614,
        1615,
        1616,
        1617,
        1618,
        1619,
        1620,
        1621,
        1622,
        1623,
        1624,
        1627,
        1745
    ],
    "resultEntity": "character",
    "actionRecords": []
}

// https://api.smash.gg/characters?videogameId=24
const roa = {
    "character": [{
            "id": 184,
            "name": "Zetterburn",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220793,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/184/image-19476019c39e66690cd4571e470afc03.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220794,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/184/image-198b73ecfed830a975324bc1780100ef.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 226096,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/184/image-2ba5fb2ec5eeaa68cbb123b44a4d19a3.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 226097,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/184/image-19476019c39e66690cd4571e470afc03.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 185,
            "name": "Orcane",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220797,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/185/image-9fea504efe37fde5da2fed9a5bef0efd.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220798,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/185/image-316ad6fdb9ea6705deaf6fceb229842d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220799,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/185/image-f3fde6ea23d888d883137cde25018ddd.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220800,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/185/image-23209b927eece8933da951e1dfeb9821.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 186,
            "name": "Wrastor",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220801,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/186/image-ecc478600b01f7d7958858703d93942b.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220802,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/186/image-392a95e91d90f7bc847697591ab92e69.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220803,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/186/image-80be8359ce4b0a694a2a394f57d8ac7f.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220804,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/186/image-843bdf4c4ec45a9dba48af2c76b81c0a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 187,
            "name": "Kragg",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220805,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/187/image-c69722a2c40ff768c851ae3d4d34f6a1.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220806,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/187/image-31b2f88daa5f56d6cb6f10ecb38f01d2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220807,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/187/image-29046ecb81f8d10b2fdc501172b95c81.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220808,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/187/image-4b9362667c5d111453e17e2fe11a193e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 188,
            "name": "Forsburn",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220809,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/188/image-d6f6c9f8e68420a8efd36b7d895d405a.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220810,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/188/image-52f6c1c23f018e5b4224101bcf4ab115.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220811,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/188/image-1e5153c374f3381bc97899a3f1af67c7.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220812,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/188/image-142d2bfa8d967ff3d5eac830ed51723e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 189,
            "name": "Maypul",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220813,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/189/image-a84e0775eaf91e7ed568ba2ceaecf758.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220814,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/189/image-51038e9a40ff35a8e9af5e6fa605e546.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220815,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/189/image-ae89a3566550bfff81673b731f2d4d37.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220816,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/189/image-743bdaf2b2fbbaad43c456d122ae18fa.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 190,
            "name": "Absa",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220817,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/190/image-1132bf9e374f34bcd95d321f86586409.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220818,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/190/image-e4a70bec74bd993f1f07629d97c49a08.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220819,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/190/image-3eb2b5e9075f30fe9e6c87b2ecbb5b01.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220820,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/190/image-9905ecd3303411668c939893528f5a05.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 191,
            "name": "Etalus",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 220821,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/191/image-344aa2bb4b1b8021b0e590da47ff3bce.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220822,
                    "width": 150,
                    "height": 150,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/191/image-24529affb2702ba9dcc2141c66e61f16.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220823,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/191/image-470820ad1a75ad35a0000419b157187a.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 220824,
                    "width": 64,
                    "height": 64,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/191/image-568d956c20c329e10f8ab6f1dd7732e7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1117,
            "name": "Ori",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 904427,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1117/image-98d2a4fc6de5e32f0d39f2f68dcc9e32.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904428,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1117/image-7732cfdf3e26dbe64319d47dbdabc750.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904429,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1117/image-98fc91411b234dff8440fdb6c27aec99.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904430,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1117/image-7732cfdf3e26dbe64319d47dbdabc750.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1118,
            "name": "Ranno",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 904431,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1118/image-f07709e0cda6a347f851341d945aca8d.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904432,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1118/image-a20384019e04644f242c9fe396aaa183.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904433,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1118/image-8f48955d8d6240e79ec84445941dffd1.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904434,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1118/image-a20384019e04644f242c9fe396aaa183.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1119,
            "name": "Clairen",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 904435,
                    "width": 100,
                    "height": 100,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1119/image-02cf4355f7a517e0a7d25c99b1a02e23.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904436,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1119/image-30530116985e52eba30bf4850a7bf27a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904437,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1119/image-e84392c3bcd3944fa43043d8508f182d.png",
                    "isOriginal": false,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 904438,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1119/image-30530116985e52eba30bf4850a7bf27a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1349,
            "name": "Sylvanos",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 1242542,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1349/image-6449a8f3bc79339fa71584903e5559a8.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1242543,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1349/image-f1cd2c7ba7daf2facc12412b90aeb730.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1350,
            "name": "Elliana",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 1242544,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1350/image-22b8aa667d2c4c8d4c8f6d8669bb9d3c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1242545,
                    "width": 32,
                    "height": 32,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1350/image-dd2d7dc4063f046902e2332d2ab55847.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1381,
            "name": "Shovel Knight",
            "isCommon": null,
            "videogameId": 24,
            "images": [{
                    "id": 1322870,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1381/image-2f4ebbc3b7dfd2c5ed1341079c1fd033.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 1322871,
                    "width": 320,
                    "height": 320,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1381/image-2f4ebbc3b7dfd2c5ed1341079c1fd033.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        }
    ],
    "result": [
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        1117,
        1118,
        1119,
        1349,
        1350,
        1381
    ],
    "resultEntity": "character",
    "actionRecords": []
}

// https://api.smash.gg/characters?videogameId=39281
const nasb = {
    "character": [{
            "id": 1877,
            "name": "Oblina",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926395,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1877/image-9ebd7e77b7755025122061e861098879.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926396,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1877/image-541c11843fed5d97205f528442eda6a2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1878,
            "name": "Aang",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926397,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1878/image-b612dd955711822e2e5b97e5ce0c350b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926398,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1878/image-0ac7150daea84c6bc52041657e991c98.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1879,
            "name": "Toph",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926399,
                    "width": 225,
                    "height": 225,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1879/image-0c70a6fa1a14d8a2860827d7cec349fd.jpg",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926400,
                    "width": 225,
                    "height": 225,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1879/image-f99e66dd04046ab9e69609623efa5fc3.jpg",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1880,
            "name": "CatDog",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926405,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1880/image-76c8414d0bafbab0b81e1d96add81c32.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926406,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1880/image-48c1b66502dbe104a23664b971e6f48f.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1881,
            "name": "Danny Phantom",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926414,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1881/image-79cb9e617fd349b0882856724b6556a1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926415,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1881/image-63591ddff1daa8bf2470db33198d4a30.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1882,
            "name": "Helga",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926419,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1882/image-81350c0544b255512f65d68a03be4a16.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926420,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1882/image-6cdd66b4dd5d36aa83fdf23af4fcddf2.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1883,
            "name": "Zim",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926421,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1883/image-d4ad15ddd4fd787b0bb2f27305c7e68a.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926422,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1883/image-0ea210fbce4b95ed30eab422af70e628.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1884,
            "name": "Korra",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926424,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1884/image-07d114c2d13706a4c8e5e6e5df1f4527.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926425,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1884/image-d1013ad3af63667b5ff87bb0c67035f1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1885,
            "name": "Lincoln",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926429,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1885/image-fa5791d7b7ee72477a083418f5c7381c.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926430,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1885/image-6cfc30693b478c275eaf70a29e00fd05.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1886,
            "name": "Lucy",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926433,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1886/image-a362e7ce3b1a4d32fbd5c7eb3b2d0b31.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926434,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1886/image-6c22bacd1d1bdb8f5215460725b0d59d.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1887,
            "name": "Ren & Stimpy",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926435,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1887/image-4f37055f3b48f02fc531ffbcc2dcf592.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926436,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1887/image-0dcee26fad6d8d284c525e8c70f3aee7.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1888,
            "name": "Reptar",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926438,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1888/image-830d756a0058f93e72ab7795b96c1141.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926439,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1888/image-88851fa59ccfbae541960ba374bb4d39.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1889,
            "name": "SpongeBob",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926440,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1889/image-c59150b050d8cd2c47ec379a872e7173.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926441,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1889/image-55212d66479ab6888eed54100411bc6b.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1890,
            "name": "Patrick",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926443,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1890/image-c7891cf84fbb7878ae5e597483a1c872.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926444,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1890/image-6f1cc19c674a0971b3729c6ac64945bc.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1891,
            "name": "Sandy",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926447,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1891/image-0a234aa4f9e1fae660d5a42ebcefe251.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926448,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1891/image-55e1b0ff5d8ea0152b41e174ebc3cde1.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1892,
            "name": "Leonardo",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926450,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1892/image-188295cfa7f8fdc1f65ceca9d6ab2ae5.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926451,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1892/image-ad81d6f97870b64a3685cc31e1b3803e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1893,
            "name": "Michelangelo",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926452,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1893/image-017ef28e6275d8344948591f9a0eb533.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926453,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1893/image-11eca99f8bea548244f52fda2ed76183.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1894,
            "name": "April",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926454,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1894/image-9c58d032800d16e7848d856509ca2ef6.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926455,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1894/image-5712dabc6a9c3976ba6425d4b94ebe44.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1895,
            "name": "Nigel",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926456,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1895/image-bfd4dfc5c6acadcf1df28b1179c0dfa8.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926457,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1895/image-c8e3d1aabd9cf56a34fd093207c26e97.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        },
        {
            "id": 1896,
            "name": "Powdered Toast Man",
            "isCommon": null,
            "videogameId": 39281,
            "images": [{
                    "id": 3926459,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "icon",
                    "url": "https://images.smash.gg/images/character/1896/image-5dd227e1891daecf58e6397f707b8f37.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                },
                {
                    "id": 3926460,
                    "width": 1080,
                    "height": 1080,
                    "ratio": 1,
                    "type": "stockIcon",
                    "url": "https://images.smash.gg/images/character/1896/image-f6f53f8acd619cab08eab8499180719e.png",
                    "isOriginal": true,
                    "entity": null,
                    "entityId": null,
                    "uploadedBy": null,
                    "createdAt": null,
                    "updatedAt": null
                }
            ],
            "characterId": null,
            "expand": [

            ]
        }
    ],
    "result": [
        1877,
        1878,
        1879,
        1880,
        1881,
        1882,
        1883,
        1884,
        1885,
        1886,
        1887,
        1888,
        1889,
        1890,
        1891,
        1892,
        1893,
        1894,
        1895,
        1896
    ],
    "resultEntity": "character",
    "actionRecords": []
}

export default {
    1386: ult,
    1: melee,
    33602: pplus,
    24: roa,
    39281: nasb,
}